export default {
	sec_10: {
		title: {
			one: '판매하기',
		},
		desc: {
			one: '암호자산 판매가 어렵나요?',
			two: '아직도 구매자를 기다리시나요?',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '암호자산 판매가',
				two: '너무 쉬워졌습니다.',
			},
			desc: {
				one: '고객과 고객간의 판매,고객이 직접 JP WORLD PAY에 판매',
				two: '선호하는 방법으로 판매하세요.',
			},
		},
		two: {
			title: {
				one: '버튼 한 번으로',
				two: '환율이 자동 적용',
			},
			desc: {
				one: '버튼 한 번으로 현재 시세가 자동으로 적용되어 바로 판매가 가능합니다.',
			},
		},
	},
};
